import React from 'react';
import PropTypes from 'prop-types';
import { StyledParagraphMargin, LabelBlock } from './style';
import { StyledWrapper, StyledHighlightWrapper } from './styleJob';
import {
  StyledDropdownInputMonths,
  StyledDropdownInputYears,
  RangeDates,
  ItemRangeDates
} from './styleEducation';

const ModCurrentJob = ({
  listMonths,
  listYears,
  company,
  onSelectUntilMonth,
  onSelectUntilYear,
  selectedUntilMonth,
  selectedUntilYear
}) => (
  <StyledHighlightWrapper>
    <StyledParagraphMargin>
      Tu actividad en {company}, dejará de ser una experiencia profesional
      actual, y pasará a formar parte de tus trabajos pasados.
    </StyledParagraphMargin>
    <StyledParagraphMargin>
      De forma automática se le asignará la fecha fin de hoy.
    </StyledParagraphMargin>
    <StyledWrapper>
      <StyledParagraphMargin>
        Si prefieres puedes modificarla aquí:
      </StyledParagraphMargin>
      <RangeDates>
        <ItemRangeDates>
          <LabelBlock id="fromRange">Fecha de fín</LabelBlock>
          <StyledDropdownInputMonths
            list={listMonths}
            selected={selectedUntilMonth}
            onSelect={onSelectUntilMonth}
            ariaLabelledby="fromRange"
            label={selectedUntilMonth}
          />
          <StyledDropdownInputYears
            list={listYears}
            selected={selectedUntilYear}
            onSelect={onSelectUntilYear}
            ariaLabelledby="fromRange"
            label={selectedUntilYear}
          />
        </ItemRangeDates>
      </RangeDates>
    </StyledWrapper>
  </StyledHighlightWrapper>
);

ModCurrentJob.propTypes = {
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  company: PropTypes.string.isRequired,
  onSelectUntilMonth: PropTypes.func,
  onSelectUntilYear: PropTypes.func,
  selectedUntilMonth: PropTypes.string.isRequired,
  selectedUntilYear: PropTypes.string.isRequired
};

export default ModCurrentJob;
